import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Eye, Droplets, Gift } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ServicesMenu() {
  const {
    t
  } = useLanguage();
  const mainServices = [{
    name: t('services.s1_name'),
    desc: t('services.s1_desc')
  }, {
    name: t('services.s2_name'),
    desc: t('services.s2_desc')
  }, {
    name: t('services.s3_name'),
    desc: t('services.s3_desc')
  }, {
    name: t('services.s4_name'),
    desc: t('services.s4_desc')
  }, {
    name: t('services.s5_name'),
    desc: t('services.s5_desc')
  }, {
    name: t('services.s6_name'),
    desc: t('services.s6_desc')
  }, {
    name: t('services.s7_name'),
    desc: t('services.s7_desc')
  }, {
    name: t('services.s8_name'),
    desc: t('services.s8_desc')
  }, {
    name: t('services.s9_name'),
    desc: t('services.s9_desc')
  }, {
    name: t('services.s10_name'),
    desc: t('services.s10_desc')
  }, {
    name: t('services.s11_name'),
    desc: t('services.s11_desc')
  }, {
    name: t('services.s12_name'),
    desc: t('services.s12_desc')
  }, {
    name: t('services.s13_name'),
    desc: t('services.s13_desc')
  }, {
    name: t('services.s14_name'),
    desc: t('services.s14_desc')
  }, {
    name: t('services.s15_name'),
    desc: t('services.s15_desc')
  }];
  const otherServices = [{
    name: t('services.o1_name'),
    desc: t('services.o1_desc')
  }, {
    name: t('services.o2_name'),
    desc: t('services.o2_desc')
  }, {
    name: t('services.o3_name'),
    desc: t('services.o3_desc')
  }, {
    name: t('services.o4_name'),
    desc: t('services.o4_desc')
  }, {
    name: t('services.o5_name'),
    desc: t('services.o5_desc')
  }];
  return <section id="servicios" className="py-12 md:py-24 bg-brand-cream relative" data-id="element-348">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-349">
        <div className="text-center mb-10 md:mb-16" data-id="element-350">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-351">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-352">
              {t('services.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full mb-6" data-id="element-353"></div>
            <p className="text-brand-charcoal max-w-2xl mx-auto mb-8" data-id="element-354">
              {t('services.subtitle')}
            </p>
            <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-gold-light text-white px-8 py-3 rounded-sm font-medium transition-colors duration-300 shadow-sm text-sm" data-id="element-355">
              <Sparkles className="w-4 h-4" data-id="element-356" />
              {t('header.bookNow')}
            </a>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-357">
          {/* Main Services List */}
          <motion.div className="lg:col-span-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-358">
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 h-full" data-id="element-359">
              <div className="flex items-center gap-3 mb-8 pb-4 border-b border-brand-gold/20" data-id="element-360">
                <Sparkles className="w-6 h-6 text-brand-gold" data-id="element-361" />
                <h3 className="text-2xl font-serif text-brand-brown" data-id="element-362">
                  {t('services.main_title')}
                </h3>
              </div>

              <div className="space-y-6" data-id="element-363">
                {mainServices.map((service, idx) => <div key={idx} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 group" data-id="element-364">
                    <h4 className="font-semibold text-brand-charcoal min-w-[250px] group-hover:text-brand-gold transition-colors" data-id="element-365">
                      {service.name}
                    </h4>
                    <div className="hidden sm:block flex-grow border-b border-dashed border-gray-300 relative top-[-6px]" data-id="element-366"></div>
                    <p className="text-sm text-gray-600 sm:text-right max-w-sm" data-id="element-367">
                      {service.desc}
                    </p>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* Sidebar Services */}
          <motion.div className="lg:col-span-4 space-y-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-368">
            {/* Eyes & Brows */}
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-369">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-370">
                <Eye className="w-6 h-6 text-brand-gold" data-id="element-371" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-372">
                  {t('services.eyes_title')}
                </h3>
              </div>

              <div className="space-y-6" data-id="element-373">
                <div data-id="element-374">
                  <h4 className="font-semibold text-brand-charcoal mb-1" data-id="element-375">
                    {t('services.e1_name')}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-376">
                    {t('services.e1_desc')}
                  </p>
                </div>
                <div data-id="element-377">
                  <h4 className="font-semibold text-brand-charcoal mb-1" data-id="element-378">
                    {t('services.e2_name')}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-379">
                    {t('services.e2_desc')}
                  </p>
                </div>
              </div>
            </div>

            {/* Other Services */}
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-380">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-381">
                <Droplets className="w-6 h-6 text-brand-gold" data-id="element-382" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-383">
                  {t('services.other_title')}
                </h3>
              </div>

              <div className="space-y-4" data-id="element-384">
                {otherServices.map((service, idx) => <div key={idx} data-id="element-385">
                    <h4 className="font-semibold text-brand-charcoal text-sm" data-id="element-386">
                      {service.name}
                    </h4>
                    <p className="text-xs text-gray-600" data-id="element-387">{service.desc}</p>
                  </div>)}
              </div>
            </div>

            {/* Gift Card */}
            <div id="gift-card" className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-388">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-389">
                <Gift className="w-6 h-6 text-brand-gold" data-id="element-390" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-391">
                  {'Gift Card '}
                </h3>
              </div>

              <div className="space-y-4" data-id="element-392">
                <img src="https://cdn.magicpatterns.com/uploads/bFyih1rHKeAGvEU9rUU7qp/gift_card_1.png" alt="Tairu Aesthetics Gift Card - The Golden Glow" className="w-full rounded-sm shadow-md" data-id="element-393" />
                <p className="text-sm text-gray-600 text-center" data-id="element-394">
                  {'Autocuidado con prop\xF3sito: Porque una piel sana no es vanidad, es salud.'}
                </p>
                <a href="https://wa.me/15513328938?text=Hola%2C%20me%20gustar%C3%ADa%20comprar%20una%20Gift%20Card" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-brand-gold hover:bg-brand-gold-light text-white py-3 rounded-sm font-medium transition-colors duration-300 shadow-sm text-sm" data-id="element-395">
                  {t('services.gift_btn')}
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}